import { BooleanFormType } from "Store/interfaces/FormTypes";
import { HouseProductIntroFormValues } from "../houseFormValuesInterfaces";

export const isHouseRegisteredAddress = (
  houseProductIntroFormValues: HouseProductIntroFormValues,
): boolean =>
  houseProductIntroFormValues.addressSameAsHomeAddress === BooleanFormType.TRUE;

export const willMoveToHouse = (
  houseProductIntroFormValues: HouseProductIntroFormValues,
): boolean =>
  houseProductIntroFormValues.addressSameAsHomeAddress ===
    BooleanFormType.FALSE &&
  houseProductIntroFormValues.recentlyBought === BooleanFormType.TRUE;
